// collection-load-more.js (fixed version)
document.addEventListener("DOMContentLoaded", function () {
  const button = document.querySelector(".load-more_btn");
  const nextUrlEl = document.querySelector("[data-next-url]");

  if (!button || !nextUrlEl) return;

  let nextUrl = nextUrlEl.dataset.nextUrl;

  button.addEventListener("click", async function () {
    if (!nextUrl) return;

    button.disabled = true;
    button.textContent = "Loading...";

    try {
      const response = await fetch(nextUrl);
      const text = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(text, "text/html");

      // Get only the product items from the next page
      const newItems = doc.querySelectorAll(".collection .grid .grid__item");
      const grid = document.querySelector(".collection .grid");

      newItems.forEach((item) => {
        // clone the item to avoid moving nodes from the old document
        let clone = item.cloneNode(true);
        grid.appendChild(clone);
      });

      // Update next URL for the load more
      const newNextUrlEl = doc.querySelector("[data-next-url]");
      nextUrl = newNextUrlEl ? newNextUrlEl.dataset.nextUrl : null;

      if (!nextUrl) {
        button.style.display = "none";
      } else {
        button.disabled = false;
        button.textContent = "Load More";
      }
    } catch (error) {
      console.error(error);
      button.textContent = "Error – Retry";
      button.disabled = false;
    }
  });
});
